var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCells(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 0l8.384 4.736v8.704L32 17.76v9.504L23.616 32 16 27.68 8.384 32 0 27.264V17.76l7.616-4.32V4.736L16 0zm7.616 14.688l-6.88 3.904V26.4l6.88 3.904 6.912-3.904v-7.808l-6.912-3.904zm-15.232 0l-6.88 3.904V26.4l6.88 3.904 6.88-3.904v-7.808l-6.88-3.904zm11.648 9.888l3.712 2.112-.736 1.248-3.712-2.08.736-1.28zm8.8-4.32l.128 4.48-1.504.032-.096-4.48 1.472-.032zm-5.824-3.328l.736 1.28-3.968 2.208-.736-1.248 3.968-2.24zM16 1.696L9.12 5.6v7.776L16 17.28l6.88-3.904V5.6L16 1.696z"
  })));
}

export default SvgCells;